var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.3927H21V17.6805H11V15.3927ZM11 19.7121H21V22H11V19.7121ZM11 11H21V13.1598H15.867H11V11Z",
    fill: "#4B5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6706 2.09229L19.2799 0.56L16.1999 2.09229L12.8199 0.56L9.67992 2.09229L4.91992 0V32L9.67992 29.6938L12.8399 31.0504L16.1999 29.6938L19.5 31.0504L23 29.6938L27.0799 32V0L22.6706 2.09229ZM25 28.5L23 27.6109L19.5 29L16.1999 27.6109L12.8399 29L9.67992 27.6109L7 28.5V16V3.5L9.67992 4.5L12.8199 3L16.1999 4.5L19.2799 3.01073L22.5 4.5L25 3.5V16V28.5Z",
    fill: "#4B5563"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.cf86965718f8c3b0dc2b345c8bdfcad2.svg";
export { ForwardRef as ReactComponent };